import { Link } from 'react-router-dom';

import { ContactForm } from '../../components/contact-form';

export default function Webinars() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>
        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources / Webinars</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Webinars
            <br />
            for practitioners and leaders
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Tactical sessions on privacy ops, evidence automation, OT security and resilience.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/resources" className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary hover:bg-white/10">
              Back to resources
            </Link>
            <Link to="/contact#contact-form" className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#3B82F6] to-[#1D4ED8] px-5 text-sm font-semibold text-white hover:opacity-95">
              Request a private session →
            </Link>
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="grid gap-4 lg:grid-cols-2">
            {[ 
              {
                t: "DPDPA readiness: controls, evidence, and penalties",
                d: "A structured walkthrough of the top implementation domains and the tech stack needed.",
                href: "/frameworks/india/dpdpa",
              },
              {
                t: "SOC evidence automation for regulated BFSI",
                d: "How to map RBI expectations to SIEM telemetry, detections and audit-ready reporting.",
                href: "/frameworks/india/rbi",
              },
              {
                t: "OT/ICS security: Purdue model and SOC integration",
                d: "Patterns for visibility, safe remote access and incident response across IT/OT.",
                href: "/ot-security",
              },
              {
                t: "Technology mapping: regulation → control → tool → evidence",
                d: "An engineering approach to standardize evidence across frameworks and vendors.",
                href: "/technology-mapping",
              },
            ].map((x) => (
              <div key={x.t} className="glass-card sheen p-6">
                <div className="text-lg font-semibold text-text-primary">{x.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{x.d}</div>
                <div className="mt-5">
                  <Link to={x.href} className="focus-ring inline-flex h-11 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-4 text-sm font-semibold text-text-primary hover:bg-white/10">
                    View reference →
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 glass-card p-6" id="contact-form">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Invite us</div>
            <div className="mt-3 text-sm text-text-secondary">We can run a tailored session for your team (DPO, CISO, audit, technology).</div>
            <div className="mt-6">
              <ContactForm title="Webinar request" subtitle="Tell us the topic and audience size." ctaLabel="Send" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
